import toast from 'react-hot-toast/headless';

interface UseToastResult {
  toast: (typeof toast)['custom'];
  dismiss: (typeof toast)['dismiss'];
  // Removes a toast immediately, skipping the leave animation (unlike dismiss).
  remove: (typeof toast)['remove'];
}

export function useToast(): UseToastResult {
  return {
    toast(content, options) {
      return toast.custom(content, options);
    },
    dismiss(...params) {
      return toast.dismiss(...params);
    },
    remove(...params) {
      return toast.remove(...params);
    },
  };
}
